var React = require('react');

function ValidInputIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_7520_4727)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.9063 3L7.10978 9.43952L4.33211 6.54452L3 7.84756L7.46389 12.5L12.5 3.95791L10.9063 3Z","fill":"#C4C4C4"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_7520_4727"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

ValidInputIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ValidInputIcon;

ValidInputIcon.default = ValidInputIcon;
